import apiClient from "./apiClient";
const resource = "/employees";

export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, { params });
  },
  async create(data) {
    return apiClient.post(`${resource}`, data);
  },
  async getById(uuid) {
    return apiClient.get(`${resource}/${uuid}`);
  },
  async update(data, uuid) {
    return apiClient.put(`${resource}/${uuid}`, data);
  },
  async delete(uuid) {
    return apiClient.delete(`${resource}/${uuid}`);
  },
  async search(keyword) {
    return apiClient.get(`${resource}/search?keyword=${keyword}`);
  },
  async getHousekeeping() {
    return apiClient.get(`${resource}/housekeeping`);
  },
};
